/**
 * Shared tab for Working Documents and All Documents: same content (IfsDocsAccordionContent).
 * Panel and nav key are derived from route via routeConfig (getDocumentPanelFromPath / getNavKeyByDocumentPanel).
 */
import { Stack } from "@fluentui/react";
import { useTheme } from "../../theme/OAS365Theme";
import IfsDocsAccordionContent from "./components/IfsDocsAccordionContent";

function DocumentTabsPage() {
  const theme = useTheme();

  return (
    <Stack
      enableScopedSelectors
      styles={{
        root: {
          background: theme.colors.backgroundColor,
          overflow: "hidden",
          height: "100%",
          minHeight: 0,
        },
      }}
      tokens={{ childrenGap: 0, padding: 0 }}
    >
        <Stack.Item
          grow
          style={{
            height: "100%",
            minHeight: 0,
            background: theme.colors.backgroundColor,
          }}
        >
          <IfsDocsAccordionContent />
        </Stack.Item>
    </Stack>
  );
}

export default DocumentTabsPage;
